import * as yup from 'yup';

export const Create_Edit_RoleFormValidation = yup.object().shape({
  role: yup.string().required('Perfil é obrigatório')
});